import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';



const routes: Routes = [
  {
    path: '',
    title: 'Nos Produits',
    loadComponent: () => import('./product.component').then(m => m.ProductComponent),
  },
  {
    path: 'category/:catSlug',
    title: 'Nos Produits',
    loadComponent: () => import('./product.component').then(m => m.ProductComponent),
  },
  {
    path: ':name',
    title: 'Détails Produit',
    loadComponent: () => import('./details-product/details-product.component').then(m => m.DetailsProductComponent),
    data: {
      disableTitleStrategy: true
    }
  },
  {
    path: ':categoryName/:name',
    title: 'Details Produit',
    loadComponent: () => import('./details-product/details-product.component').then(m => m.DetailsProductComponent),
    data: {
      disableTitleStrategy: true
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductRoutingModule {
}
